export default __webpack_public_path__ + "static/media/blue_anim.a1869a86.gif";